{
  "ReportingMenu_FirstClosePopup": "To reopen the menu, click the 'Analytics' button in the sidebar whilst on the Analytics page.",
  "NAME": "ReportingMenuLanguage"
}